import api from '@/api/api'

const state = {
  favouriteGroups: [],
}

const mutations = {
  GET_FAVOURITE_GROUPS: (state, data) => {
    state.favouriteGroups = data
  },

  CREATE_FAVOURITE_GROUP: (state, data) => {
    state.favouriteGroups.unshift(data)
  },

  DELETE_FAVOURITE_GROUP: (state, id) => {
    state.favouriteGroups = state.favouriteGroups.filter(el => {
      return el.id !== id
    })
  },

  EDIT_FAVOURITE_GROUP: (state, data) => {
    const groupIndex = state.favouriteGroups.findIndex(x => x.id === data.id)
    state.favouriteGroups[groupIndex].name = data.name
  },

  ADD_FAVOURITE: (state, data) => {
    const groupIndex = state.favouriteGroups.findIndex(x => x.id == data.favouriteGroupId)
    state.favouriteGroups[groupIndex].favourites.push(data)
  },

  REMOVE_FAVOURITE: (state, data) => {
    const groupIndex = state.favouriteGroups.findIndex(x => x.id === data.favouriteGroupId)
    const elementIndex = state.favouriteGroups[groupIndex].favourites.findIndex(
      x => x.id === data.id
    )
    state.favouriteGroups[groupIndex].favourites.splice(elementIndex, 1)
  },

  CLEAR_FAVOURITES: state => {
    state.favouriteGroups = []
  },
}

const actions = {
  loadFavourites: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .getFavouriteGroups()
        .then(response => {
          commit('GET_FAVOURITE_GROUPS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  removeFavouriteGroup: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .deleteFavouriteGroup(id)
        .then(response => {
          commit('DELETE_FAVOURITE_GROUP', id)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  addFavouriteGroup: ({ commit, rootState }, groupName) => {
    return new Promise((resolve, reject) => {
      const data = {
        name: groupName,
        creation_date: new Date(),
        userId: rootState.user.id,
        favourites: [],
      }
      api
        .postFavouriteGroup(data)
        .then(response => {
          commit('CREATE_FAVOURITE_GROUP', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  editFavouriteGroup: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      const { id } = data
      api
        .patchFavouriteGroup(id, data)
        .then(response => {
          commit('EDIT_FAVOURITE_GROUP', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  addFavourite: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      api
        .postFavourite(data)
        .then(response => {
          commit('ADD_FAVOURITE', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  removeFavourite: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      const { id } = data
      api
        .deleteFavourite(id)
        .then(response => {
          commit('REMOVE_FAVOURITE', data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  clearFavourites: ({ commit }) => {
    commit('CLEAR_FAVOURITES')
  },
}

const getters = {
  favouriteGroups: state => {
    return state.favouriteGroups
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
